/**
 * File: receiptMessageUtils.ts
 * Path: apps/admin/src/shared/utils/receiptMessageUtils.ts
 * Description: What marking a contract payment received did in the books, in
 * one sentence for the toast: which invoices it paid, and what is held as
 * the client's credit until its invoice is made.
 */
import { formatCents, type ReceiptBookingResult } from "@idk/config";

/** Null when there is nothing to say. */
export const receiptMessage = (result: ReceiptBookingResult): string | null => {
  if (!result.booked) return result.reason;
  const paid = result.allocations.map((a) => `${formatCents(a.cents)} pays ${a.number}`);
  const held = result.creditCents > 0 ? [`${formatCents(result.creditCents)} is held as the client's credit until its invoice is made`] : [];
  return `Booked: ${[...paid, ...held].join("; ")}.`;
};
